import { useAuthenticatedSWR } from '../api';
import { ALLERGIES_URL } from './constants';

export const useAllergies = () => {
  const { data } = useAuthenticatedSWR(ALLERGIES_URL);
  return data;
};
